module.exports = __webpack_public_path__ + "img/miller-high-life-centered-logo.922fbd55.png";